import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import { ToolkitApiService } from '@jeppesen-foreflight/jmkw-toolkit';
import { EsriViewType } from '@jeppesen-foreflight/jmkw-types';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'jmkw-view-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-toggle.component.html',
  styleUrls: ['./view-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewToggleComponent {
  private _jmkwApi = inject(ToolkitApiService);
  private _dialogRef = inject(DialogRef);
  show2d = computed(() => this._jmkwApi.getViews()['2D'].visible);
  show3d = computed(() => this._jmkwApi.getViews()['3D'].visible);

  handleViewClick(esriViewType: EsriViewType) {
    this._jmkwApi.toggleView(esriViewType);
    this._dialogRef.close();
  }
}
